<template>
  <div class="cashier-checkout">
    <section class="cart-panel">
      <div class="cart-workspace">
        <div class="cart-content">
          <div class="member-card" @click="memberDialog = true">
            <el-avatar :src="currentMember.avatar || defaultAvatar"></el-avatar>
            <div class="member-info">
              <strong>{{ isGuest ? '散客' : (currentMember.name || currentMember.mobile || currentMember.user_id || '未命名会员') }}</strong>
              <span v-if="!isGuest">积分 {{ currentMember.integral || 0 }}　余额 ￥{{ money(currentMember.balance) }}</span>
              <span v-else>点击选择会员，支持手机号/昵称搜索</span>
            </div>
            <el-button type="text">切换</el-button>
          </div>

          <div class="cart-head">
            <span>已选购 {{ totalCount }} 件</span>
            <div class="cart-head-actions">
              <el-button v-if="cartList.length" type="text" icon="el-icon-tickets" @click="saveHold">挂单</el-button>
              <el-button type="text" icon="el-icon-document-copy" @click="openHoldDialog">取单</el-button>
              <el-button type="text" icon="el-icon-delete" @click="clearCart">清空</el-button>
            </div>
          </div>

          <div class="cart-list" v-if="cartList.length">
            <div class="cart-item" v-for="item in cartList" :key="item.key">
              <img :src="item.img || defaultGoodsImg" />
              <div class="cart-item-main">
                <div class="cart-title">{{ item.title }}</div>
                <div class="cart-spec">{{ item.spec_title || '默认' }}</div>
                <div class="cart-price">￥{{ money(item.price) }}</div>
              </div>
              <div class="cart-stepper">
                <el-button icon="el-icon-minus" circle size="mini" @click="changeQty(item, -1)"></el-button>
                <span>{{ item.quantity }}</span>
                <el-button icon="el-icon-plus" circle size="mini" type="primary" @click="changeQty(item, 1)"></el-button>
                <el-button type="text" @click="removeItem(item)">删除</el-button>
              </div>
            </div>
          </div>
          <div class="cart-empty" v-else>
            <i class="el-icon-shopping-cart-2"></i>
            <span>请选择商品</span>
          </div>
        </div>
      </div>

      <div class="cart-tools">
        <button type="button" class="tool-action" @click="openCouponDialog">
          <i class="el-icon-price-tag"></i>
          <span>优惠券</span>
        </button>
        <button type="button" class="tool-action" @click="discountDialog = true">
          <i class="el-icon-edit-outline"></i>
          <span>改价</span>
        </button>
        <button type="button" class="tool-action" @click="remarkDialog = true">
          <i class="el-icon-chat-line-square"></i>
          <span>备注</span>
        </button>
      </div>

      <div class="summary">
        <div><span>商品金额</span><b>￥{{ money(goodsAmount) }}</b></div>
        <div><span>优惠券</span><b>-￥{{ money(couponAmount) }}</b></div>
        <div><span>手工优惠</span><b>-￥{{ money(manualDiscount) }}</b></div>
        <div><span>抹零</span><b>-￥{{ money(roundingAmount) }}</b></div>
        <div class="payable"><span>应收</span><b>￥{{ money(payAmount) }}</b></div>
      </div>
      <el-button class="pay-btn" type="primary" :disabled="!cartList.length" @click="openPay">收款 ￥{{ money(payAmount) }}</el-button>
    </section>

    <section class="goods-panel">
      <div class="goods-toolbar">
        <div class="goods-toolbar-row">
          <el-tabs v-model="goodsType" class="goods-tabs" @tab-click="handleGoodsSearch">
            <el-tab-pane label="商品" name="1"></el-tab-pane>
          </el-tabs>
          <el-select v-model="search.menu" clearable placeholder="全部分类" size="small" @change="handleGoodsSearch">
            <el-option v-for="item in menuList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <el-input
            v-model="search.keywords"
            size="small"
            clearable
            prefix-icon="el-icon-search"
            placeholder="搜索商品名/条码"
            @keyup.enter.native="handleGoodsSearch"
          >
            <el-button slot="append" @click="handleGoodsSearch">搜索</el-button>
          </el-input>
        </div>
      </div>

      <div class="goods-grid" v-loading="goodsLoading">
        <div
          class="goods-card"
          v-for="item in goodsList"
          :key="item.id"
          :class="{disabled: Number(item.stock) <= 0, selected: getGoodsCount(item.id) > 0}"
          @click="chooseGoods(item)"
        >
          <img :src="item.img || defaultGoodsImg" />
          <span class="goods-count" v-if="getGoodsCount(item.id) > 0">{{ getGoodsCount(item.id) }}</span>
          <div class="goods-meta">
            <div class="goods-title">{{ item.title }}</div>
            <div class="goods-stock">库存 {{ item.stock }}</div>
            <strong>￥{{ money(item.price) }}</strong>
          </div>
        </div>
      </div>
      <el-pagination
        small
        background
        layout="prev, pager, next"
        :page-size="search.page_size"
        :total="search.total"
        @current-change="changeGoodsPage"
      ></el-pagination>
    </section>

    <el-dialog title="选择规格" :visible.sync="specDialog" width="520px">
      <div class="spec-list">
        <div
          class="spec-item"
          v-for="spec in specList"
          :key="spec.id"
          :class="{disabled: Number(spec.stock) <= 0}"
          @click="addGoods(activeGoods, spec)"
        >
          <span>{{ spec.title || '默认规格' }}</span>
          <strong>￥{{ money(spec.price) }}</strong>
          <em>库存 {{ spec.stock }}</em>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="选择优惠券" :visible.sync="couponDialog" width="720px">
      <div class="coupon-current" v-if="selectedCoupon">
        已选择：{{ selectedCoupon.title }}，优惠 ￥{{ money(couponAmount) }}
        <el-button type="text" @click="clearCoupon">取消使用</el-button>
      </div>
      <el-table :data="couponList" size="mini" height="360">
        <el-table-column prop="title" label="优惠券"></el-table-column>
        <el-table-column label="优惠" width="110">
          <template slot-scope="scope">{{ couponText(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="goods_name" label="适用商品" width="160">
          <template slot-scope="scope">{{ scope.row.goods_name || '通用' }}</template>
        </el-table-column>
        <el-table-column prop="end_time" label="有效期至" width="150"></el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="selectCoupon(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="coupon-empty" v-if="couponList.length === 0">当前会员暂无可用优惠券</div>
    </el-dialog>

    <el-dialog title="选择会员" :visible.sync="memberDialog" width="800px">
      <div class="member-dialog-body">
        <el-button size="small" @click="useGuest">使用散客</el-button>
        <member-list :type="1" :selectFunc="selectMember"></member-list>
      </div>
    </el-dialog>

    <el-dialog title="取单" :visible.sync="holdDialog" width="820px">
      <div class="hold-dialog-search">
        <el-input
          v-model="holdSearch.keywords"
          size="small"
          clearable
          placeholder="搜索挂单号/会员/商品"
          @keyup.enter.native="handleHoldSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleHoldSearch"></el-button>
        </el-input>
      </div>
      <el-table v-loading="holdLoading" :data="holdList" size="mini" height="420">
        <el-table-column prop="hold_no" label="挂单号" width="165"></el-table-column>
        <el-table-column label="会员" width="140">
          <template slot-scope="scope">{{ memberName(scope.row.member) }}</template>
        </el-table-column>
        <el-table-column prop="count" label="件数" width="70" align="center"></el-table-column>
        <el-table-column label="金额" width="100" align="center">
          <template slot-scope="scope">￥{{ money(scope.row.amount) }}</template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope">{{ holdGoodsText(scope.row.goods) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="86" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="pickHold(scope.row)">取单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="改价" :visible.sync="discountDialog" width="420px">
      <el-form label-width="90px" size="small">
        <el-form-item label="手工优惠">
          <el-input-number v-model="manualDiscount" :min="0" :max="goodsAmount" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="抹零">
          <el-input-number v-model="roundingAmount" :min="0" :max="goodsAmount" :precision="2"></el-input-number>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="订单备注" :visible.sync="remarkDialog" width="460px">
      <el-input v-model="remark" type="textarea" :rows="4" placeholder="收银备注"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="remarkDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmRemark">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="payDialog" width="560px" custom-class="cashier-pay-dialog">
      <div class="pay-box">
        <div class="pay-label">应收金额</div>
        <div class="pay-amount">￥{{ money(payAmount) }}</div>
        <el-input
          v-model="payCode"
          class="pay-code-input"
          placeholder="请点击输入框聚焦扫码或输入编码号"
          clearable
          autofocus
        ></el-input>
        <div class="pay-pending-tip" v-if="payPending">{{ pendingPayment.errmsg || '用户支付中，请等待用户确认' }}</div>
        <div class="pay-methods">
          <button type="button" :class="{active: paymentType === 'wechat'}" @click="paymentType = 'wechat'">
            <i class="el-icon-chat-dot-square green"></i>
            <span>微信收款</span>
          </button>
          <button type="button" :class="{active: paymentType === 'alipay'}" @click="paymentType = 'alipay'">
            <i class="el-icon-s-promotion blue"></i>
            <span>支付宝</span>
          </button>
          <button type="button" :class="{active: paymentType === 'cash'}" @click="paymentType = 'cash'">
            <i class="el-icon-money red"></i>
            <span>现金收款</span>
          </button>
        </div>
        <div class="keypad">
          <button type="button" @click="appendPayCode('1')">1</button>
          <button type="button" @click="appendPayCode('2')">2</button>
          <button type="button" @click="appendPayCode('3')">3</button>
          <button type="button" class="back-key" @click="backspacePayCode"><i class="el-icon-back"></i></button>
          <button type="button" @click="appendPayCode('4')">4</button>
          <button type="button" @click="appendPayCode('5')">5</button>
          <button type="button" @click="appendPayCode('6')">6</button>
          <button type="button" class="clear-key" @click="clearPayCode">C</button>
          <button type="button" @click="appendPayCode('7')">7</button>
          <button type="button" @click="appendPayCode('8')">8</button>
          <button type="button" @click="appendPayCode('9')">9</button>
          <button type="button" class="confirm-key" :disabled="payLoading && !payPending" @click="confirmPay">{{ payLoading ? (payPending ? '等待确认' : '收款中') : '确认' }}</button>
          <button type="button" @click="appendPayCode('0')">0</button>
          <button type="button" @click="appendPayCode('00')">00</button>
          <button type="button" @click="appendPayCode('.')">.</button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="收款成功" :visible.sync="payResultDialog" width="430px" custom-class="cashier-result-dialog">
      <div class="pay-result-box">
        <i class="el-icon-success"></i>
        <div class="result-amount">￥{{ money(lastPayOrder.amount) }}</div>
        <div class="result-row"><span>订单号</span><strong>{{ lastPayOrder.order_sn }}</strong></div>
        <div class="result-row"><span>支付方式</span><strong>{{ payTypeText(lastPayOrder.pay_type) }}</strong></div>
        <div class="result-row" v-if="lastPayOrder.payment_sn"><span>支付单号</span><strong>{{ lastPayOrder.payment_sn }}</strong></div>
        <div class="result-row" v-if="lastPayOrder.trade_sn"><span>交易单号</span><strong>{{ lastPayOrder.trade_sn }}</strong></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="payResultDialog = false">继续收银</el-button>
        <el-button size="small" type="primary" @click="goOrderDetail">查看订单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MemberList from '@/components/Member/MemberList'

export default {
  components: {
    MemberList
  },
  data() {
    return {
      defaultAvatar: this.config.SOURCE_DOMAIN + '/images/head.png',
      defaultGoodsImg: this.config.SOURCE_DOMAIN + '/images/default.png',
      goodsType: '1',
      goodsLoading: false,
      goodsList: [],
      menuList: [],
      search: {
        keywords: '',
        menu: '',
        page: 1,
        page_size: 24,
        total: 0
      },
      cartList: [],
      currentMember: {},
      memberDialog: false,
      activeGoods: false,
      specDialog: false,
      specList: [],
      discountDialog: false,
      remarkDialog: false,
      couponDialog: false,
      holdDialog: false,
      holdLoading: false,
      holdList: [],
      holdSearch: {
        keywords: '',
        page: 1,
        page_size: 50
      },
      payDialog: false,
      manualDiscount: 0,
      roundingAmount: 0,
      selectedCoupon: false,
      couponList: [],
      remark: '',
      paymentType: 'wechat',
      payCode: '',
      payLoading: false,
      payPending: false,
      pendingPayment: {},
      payQueryTimer: null,
      payQueryTimes: 0,
      activeHoldId: 0,
      payResultDialog: false,
      lastPayOrder: {}
    }
  },
  computed: {
    isGuest() {
      return !this.currentMember || Number(this.currentMember.id || 0) === 0
    },
    totalCount() {
      return this.cartList.reduce((sum, item) => sum + Number(item.quantity), 0)
    },
    goodsAmount() {
      return this.cartList.reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0)
    },
    payAmount() {
      const amount = this.goodsAmount - Number(this.couponAmount || 0) - Number(this.manualDiscount || 0) - Number(this.roundingAmount || 0)
      return amount > 0 ? amount : 0
    },
    couponAmount() {
      if (!this.selectedCoupon) return 0
      if (Number(this.selectedCoupon.coupon_type) === 1) {
        return Math.min(Number(this.selectedCoupon.coupon_val || 0), this.goodsAmount)
      }
      if (Number(this.selectedCoupon.coupon_type) === 2) {
        const discount = Number(this.selectedCoupon.coupon_val || 10)
        return Math.max(0, this.goodsAmount - this.goodsAmount * discount / 10)
      }
      return 0
    }
  },
  created() {
    this.restoreHold()
    this.getMenus()
    this.getGoodsList()
  },
  beforeDestroy() {
    this.clearPayQueryTimer()
  },
  methods: {
    money(value) {
      return Number(value || 0).toFixed(2)
    },
    payTypeText(type) {
      const map = {
        1: '微信收款',
        2: '支付宝',
        3: '现金收款'
      }
      return map[Number(type)] || '-'
    },
    getMenus() {
      this.$api.goods.menuAll({}, res => {
        if (res.errcode === 0) {
          this.menuList = res.data || []
        }
      })
    },
    getGoodsList() {
      this.goodsLoading = true
      const params = {
        keywords: this.search.keywords,
        menu: this.search.menu,
        goods_type: this.goodsType,
        status: 1,
        page: this.search.page,
        page_size: this.search.page_size
      }
      this.$api.goods.goodsIndex(params, res => {
        this.goodsLoading = false
        if (res.errcode === 0) {
          this.goodsList = res.data.data || []
          this.search.total = res.data.total || 0
        }
      })
    },
    handleGoodsSearch() {
      this.search.page = 1
      this.getGoodsList()
    },
    changeGoodsPage(page) {
      this.search.page = page
      this.getGoodsList()
    },
    getGoodsCount(goodsId) {
      return this.cartList
        .filter(item => Number(item.goods_id) === Number(goodsId))
        .reduce((sum, item) => sum + Number(item.quantity), 0)
    },
    chooseGoods(item) {
      if (Number(item.stock) <= 0) {
        this.fail('商品库存不足')
        return
      }
      this.$api.goods.goodsInfo({id: item.id}, res => {
        if (res.errcode !== 0) return
        const info = res.data
        this.activeGoods = info
        if (info.is_sku === 1 && info.specsList && info.specsList.length) {
          this.specList = info.specsList
          this.specDialog = true
        } else {
          this.addGoods(info, false)
        }
      })
    },
    addGoods(goods, spec) {
      if (spec && Number(spec.stock) <= 0) {
        this.fail('规格库存不足')
        return
      }
      const key = `${goods.id}_${spec ? spec.id : 0}`
      const exist = this.cartList.find(item => item.key === key)
      if (exist) {
        exist.quantity += 1
      } else {
        this.cartList.push({
          key,
          goods_id: goods.id,
          specs_id: spec ? spec.id : 0,
          title: goods.title,
          spec_title: spec ? spec.title : '',
          img: (spec && spec.img) || goods.img,
          price: Number(spec ? spec.price : goods.price),
          stock: Number(spec ? spec.stock : goods.stock),
          quantity: 1
        })
      }
      this.specDialog = false
    },
    changeQty(item, delta) {
      const next = item.quantity + delta
      if (next <= 0) {
        this.removeItem(item)
        return
      }
      if (next > item.stock) {
        this.fail('不能超过库存')
        return
      }
      item.quantity = next
    },
    removeItem(item) {
      this.cartList = this.cartList.filter(child => child.key !== item.key)
    },
    clearCart() {
      this.cartList = []
      this.manualDiscount = 0
      this.roundingAmount = 0
      this.selectedCoupon = false
      this.remark = ''
      this.activeHoldId = 0
    },
    selectMember(member) {
      this.currentMember = member
      this.memberDialog = false
    },
    useGuest() {
      this.currentMember = {id: 0}
      this.memberDialog = false
    },
    memberName(member) {
      if (!member || Number(member.id || 0) === 0) return '散客'
      return member.name || member.mobile || member.user_id || '未命名会员'
    },
    holdGoodsText(goods) {
      return (goods || []).map(item => `${item.title} x${item.quantity}`).join('，')
    },
    restoreHold() {
      const hold = sessionStorage.getItem('DSHOP_CASHIER_RESTORE')
      if (!hold) return
      try {
        const data = JSON.parse(hold)
        this.applyHold(data)
        this.success('挂单已恢复')
      } catch (e) {
        this.fail('挂单恢复失败')
      }
      sessionStorage.removeItem('DSHOP_CASHIER_RESTORE')
    },
    applyHold(data) {
      this.cartList = data.goods || []
      this.currentMember = data.member || {}
      this.manualDiscount = Number(data.manualDiscount || 0)
      this.roundingAmount = Number(data.roundingAmount || 0)
      this.selectedCoupon = data.selectedCoupon || false
      this.remark = data.remark || ''
      this.activeHoldId = data.id || 0
    },
    saveHold() {
      if (!this.cartList.length) {
        this.fail('请先选择商品')
        return
      }
      this.$api.order.orderHoldSave({
        member_id: this.currentMember && this.currentMember.id ? this.currentMember.id : 0,
        goods: this.cartList,
        manualDiscount: this.manualDiscount,
        roundingAmount: this.roundingAmount,
        selectedCoupon: this.selectedCoupon,
        remark: this.remark,
        amount: this.payAmount,
        count: this.totalCount
      }, res => {
        if (res.errcode !== 0) {
          this.fail(res.errmsg || '挂单失败')
          return
        }
        this.clearCart()
        this.activeHoldId = 0
        this.success('挂单成功')
      })
    },
    openHoldDialog() {
      this.holdDialog = true
      this.handleHoldSearch()
    },
    handleHoldSearch() {
      this.holdSearch.page = 1
      this.getHoldList()
    },
    getHoldList() {
      this.holdLoading = true
      this.$api.order.orderHoldIndex({
        keywords: this.holdSearch.keywords,
        page: this.holdSearch.page,
        page_size: this.holdSearch.page_size
      }, res => {
        this.holdLoading = false
        if (res.errcode !== 0) {
          this.fail(res.errmsg || '获取挂单失败')
          return
        }
        this.holdList = res.data.data || []
      })
    },
    pickHold(row) {
      const restore = () => {
        this.$api.order.orderHoldRestore({id: row.id}, res => {
          if (res.errcode !== 0) {
            this.fail(res.errmsg || '取单失败')
            return
          }
          this.applyHold(res.data)
          this.holdDialog = false
          this.success('取单成功')
        })
      }
      if (this.cartList.length) {
        this.$confirm('当前已选商品会被取单内容覆盖，确认取单吗？', '提示', {type: 'warning'}).then(restore).catch(() => {})
        return
      }
      restore()
    },
    openPay() {
      this.clearPayQueryTimer()
      this.payCode = ''
      this.paymentType = 'wechat'
      this.payLoading = false
      this.payPending = false
      this.pendingPayment = {}
      this.payQueryTimes = 0
      this.payDialog = true
    },
    openCouponDialog() {
      if (this.isGuest) {
        this.fail('请先选择会员')
        return
      }
      this.couponDialog = true
      this.$api.marking.couponLog({
        member_id: this.currentMember.id,
        status: 2,
        coupon_status: 1,
        page_size: 50
      }, res => {
        if (res.errcode === 0) {
          this.couponList = res.data.data || []
        }
      })
    },
    couponText(coupon) {
      if (Number(coupon.coupon_type) === 1) return `￥${this.money(coupon.coupon_val)}`
      if (Number(coupon.coupon_type) === 2) return `${coupon.coupon_val}折`
      return coupon.goods_name || '兑换券'
    },
    selectCoupon(coupon) {
      this.selectedCoupon = coupon
      this.couponDialog = false
      this.success('优惠券已选择')
    },
    clearCoupon() {
      this.selectedCoupon = false
    },
    appendPayCode(key) {
      this.payCode += key
    },
    backspacePayCode() {
      this.payCode = this.payCode.slice(0, -1)
    },
    clearPayCode() {
      this.payCode = ''
    },
    confirmRemark() {
      this.remarkDialog = false
      this.success('备注已保存')
    },
    confirmPay() {
      if (this.payPending && this.pendingPayment.payment_sn) {
        this.queryPayResult(true)
        return
      }
      if (this.payLoading) return
      if (!this.cartList.length) {
        this.fail('请先选择商品')
        return
      }
      const payTypeMap = {
        wechat: 1,
        alipay: 2,
        cash: 3
      }
      if (this.paymentType !== 'cash' && !this.payCode) {
        this.fail('请扫描或输入付款码')
        return
      }
      this.payLoading = true
      this.$api.order.cashierOrderCreate({
        member_id: this.currentMember && this.currentMember.id ? this.currentMember.id : 0,
        goods: this.cartList.map(item => ({
          goods_id: item.goods_id,
          specs_id: item.specs_id,
          sum: item.quantity
        })),
        coupon_id: this.selectedCoupon ? this.selectedCoupon.id : 0,
        manual_discount: this.manualDiscount,
        rounding_amount: this.roundingAmount,
        is_use_integral: 0,
        is_use_amount: 0,
        pay_type: payTypeMap[this.paymentType],
        auth_code: this.payCode,
        hold_id: this.activeHoldId,
        remark: this.remark
      }, res => {
        if (res.errcode !== 0) {
          this.payLoading = false
          this.fail(res.errmsg || '收款失败')
          return
        }
        if (res.data && Number(res.data.pay_pending || 0) === 1) {
          this.waitPayResult(Object.assign({}, res.data, {
            amount: this.payAmount,
            pay_type: payTypeMap[this.paymentType]
          }))
          return
        }
        this.payLoading = false
        this.handlePaySuccess(Object.assign({}, res.data || {}, {
          amount: this.payAmount,
          pay_type: payTypeMap[this.paymentType]
        }))
      })
    },
    waitPayResult(data) {
      this.payLoading = true
      this.payPending = true
      this.pendingPayment = data
      this.payQueryTimes = 0
      this.clearPayQueryTimer()
      this.success(data.errmsg || '用户支付中，请等待用户确认')
      this.payQueryTimer = setInterval(() => {
        this.queryPayResult(false)
      }, 2000)
    },
    queryPayResult(manual) {
      if (!this.pendingPayment.payment_sn) return
      this.payQueryTimes += 1
      this.$api.order.cashierPayQuery({
        payment_sn: this.pendingPayment.payment_sn
      }, res => {
        if (res.errcode !== 0) {
          if (manual) this.fail(res.errmsg || '支付查询失败')
          return
        }
        if (res.data && Number(res.data.pay_status || 0) === 1) {
          this.handlePaySuccess(Object.assign({}, this.pendingPayment, res.data))
          return
        }
        if (manual) this.fail((res.data && res.data.errmsg) || '用户支付中，请稍后再查')
        if (this.payQueryTimes >= 90) {
          this.clearPayQueryTimer()
          this.payLoading = false
          this.fail('支付确认超时，请稍后在订单列表确认支付状态')
        }
      })
    },
    clearPayQueryTimer() {
      if (this.payQueryTimer) {
        clearInterval(this.payQueryTimer)
        this.payQueryTimer = null
      }
    },
    handlePaySuccess(data) {
      this.clearPayQueryTimer()
      this.payLoading = false
      this.payPending = false
      this.pendingPayment = {}
      this.payDialog = false
      this.lastPayOrder = Object.assign({}, data || {}, {
        amount: data.amount || this.payAmount
      })
      this.clearCart()
      this.getGoodsList()
      this.payResultDialog = true
    },
    goOrderDetail() {
      if (!this.lastPayOrder || !this.lastPayOrder.order_id) return
      this.payResultDialog = false
      this.$router.push({name: 'order_detail', params: {id: this.lastPayOrder.order_id}})
    }
  }
}
</script>

<style scoped>
.cashier-checkout {
  display: grid;
  grid-template-columns: 480px 1fr;
  gap: 18px;
  height: calc(100vh - 28px);
  min-height: 0;
  overflow: hidden;
}
.cart-panel,
.goods-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(20, 40, 70, .06);
}
.cart-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}
.cart-workspace {
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}
.cart-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.member-card {
  margin: 14px 14px 12px 14px;
  border: 2px solid #ff8a00;
  border-radius: 8px;
  padding: 12px 16px 12px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.member-card .el-button {
  flex-shrink: 0;
  margin-left: 8px;
}
.member-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.member-info span {
  color: #667085;
  font-size: 13px;
}
.cart-head,
.summary div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cart-head {
  padding: 0 14px 10px 14px;
  border-bottom: 1px solid #edf0f5;
}
.cart-head-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cart-head-actions /deep/ .el-button {
  padding: 0;
}
.cart-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 6px 14px 6px 14px;
}
.cart-item {
  display: grid;
  grid-template-columns: 64px 1fr 108px;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f7;
}
.cart-item img,
.goods-card img,
.member-line img {
  object-fit: cover;
  background: #f4f6f8;
}
.cart-item img {
  width: 64px;
  height: 64px;
  border-radius: 6px;
}
.cart-title {
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}
.cart-spec,
.goods-stock {
  color: #8a96a8;
  font-size: 12px;
  margin-top: 4px;
}
.cart-price,
.goods-card strong {
  color: #f5222d;
  font-weight: 700;
  margin-top: 6px;
}
.cart-stepper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  flex-wrap: wrap;
}
.cart-empty {
  flex: 1;
  color: #98a2b3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
}
.cart-empty i {
  font-size: 42px;
}
.cart-tools {
  padding: 10px 14px;
  border-top: 1px solid #edf0f5;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  background: #fbfcfe;
}
.tool-action {
  flex: 1;
  height: 42px;
  border: 0;
  border-radius: 21px;
  background: #fff;
  color: #344054;
  box-shadow: 0 2px 8px rgba(20, 40, 70, .08);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
}
.tool-action i {
  font-size: 18px;
}
.tool-action span {
  font-size: 13px;
  line-height: 16px;
}
.tool-action:hover {
  color: #1688ff;
  background: #eef7ff;
}
.summary {
  padding: 12px 18px;
  line-height: 28px;
}
.summary span {
  color: #667085;
}
.summary .payable {
  font-size: 20px;
  color: #111827;
  border-top: 1px dashed #d9dee8;
  margin-top: 8px;
  padding-top: 10px;
}
.summary .payable b {
  color: #1688ff;
}
.pay-btn {
  height: 54px;
  margin: 0 18px 18px;
  border-radius: 27px;
  font-size: 20px;
}
.goods-panel {
  padding: 12px 14px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.goods-toolbar {
  background: #fff;
  margin-bottom: 10px;
}
.goods-toolbar-row {
  display: grid;
  grid-template-columns: 96px 180px minmax(260px, 1fr);
  align-items: start;
  gap: 12px;
  margin-bottom: 0;
}
.goods-tabs /deep/ .el-tabs__header {
  margin: 0;
}
.goods-tabs /deep/ .el-tabs__nav-wrap::after {
  display: none;
}
.goods-tabs /deep/ .el-tabs__item {
  height: 32px;
  line-height: 32px;
  font-weight: 600;
}
.goods-tabs /deep/ .el-tabs__active-bar {
  bottom: 1px;
}
.goods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  grid-auto-rows: 94px;
  align-content: start;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 2px 8px 0;
}
.goods-card {
  position: relative;
  height: 94px;
  background: #f8fafc;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px;
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 9px;
  cursor: pointer;
}
.goods-card:hover {
  border-color: #1688ff;
  background: #eef7ff;
}
.goods-card.disabled {
  opacity: .5;
}
.goods-card.selected {
  border-color: #1688ff;
  background: #eef7ff;
}
.goods-card img {
  width: 72px;
  height: 76px;
  border-radius: 6px;
}
.goods-count {
  position: absolute;
  right: -4px;
  top: -5px;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background: #ff8a00;
  color: #fff;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  font-weight: 700;
  box-shadow: 0 2px 7px rgba(255, 138, 0, .35);
}
.goods-title {
  line-height: 20px;
  height: 40px;
  overflow: hidden;
}
.spec-list {
  display: grid;
  gap: 10px;
}
.spec-item {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr 100px 90px;
  cursor: pointer;
}
.spec-item:hover {
  border-color: #1688ff;
}
.spec-item.disabled {
  opacity: .5;
}
.member-dialog-body /deep/ .demo-form-inline {
  padding-right: 96px;
}
.member-dialog-body > .el-button {
  position: absolute;
  right: 20px;
  top: 76px;
  z-index: 2;
}
.coupon-current {
  margin-bottom: 12px;
  padding: 9px 12px;
  border-radius: 6px;
  background: #eef7ff;
  color: #1688ff;
}
.coupon-empty {
  padding: 18px 0 0;
  text-align: center;
  color: #8a96a8;
}
.hold-dialog-search {
  width: 360px;
  margin-bottom: 12px;
}
/deep/ .cashier-pay-dialog .el-dialog__header {
  padding: 0;
}
/deep/ .cashier-pay-dialog .el-dialog__body {
  padding: 28px 44px 24px;
}
.pay-box {
  text-align: center;
}
.pay-label {
  color: #8a96a8;
  font-size: 15px;
  margin-bottom: 8px;
}
.pay-amount {
  color: #1f2937;
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 20px;
}
.pay-code-input {
  margin-bottom: 12px;
}
.pay-code-input /deep/ .el-input__inner {
  height: 56px;
  font-size: 16px;
}
.pay-pending-tip {
  min-height: 20px;
  margin-bottom: 12px;
  color: #ff8a00;
  font-size: 13px;
  text-align: left;
}
.pay-methods {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}
.pay-methods button {
  height: 86px;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #111827;
}
.pay-methods button.active {
  border-color: #1688ff;
  box-shadow: 0 0 0 2px rgba(22, 136, 255, .08);
}
.pay-methods i {
  font-size: 28px;
}
.pay-methods .green {
  color: #24c267;
}
.pay-methods .blue {
  color: #1688ff;
}
.pay-methods .red {
  color: #f04438;
}
.keypad {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}
.keypad button {
  height: 56px;
  border: 0;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(20, 40, 70, .08);
  font-size: 24px;
  cursor: pointer;
}
.keypad button:hover {
  background: #eef7ff;
  color: #1688ff;
}
.keypad .confirm-key {
  grid-column: 4;
  grid-row: 3 / span 2;
  height: 118px;
  background: #1688ff;
  color: #fff;
  font-size: 22px;
}
.keypad .confirm-key:hover {
  background: #0f7ae5;
  color: #fff;
}
.keypad .confirm-key:disabled {
  cursor: not-allowed;
  opacity: .68;
}
/deep/ .cashier-result-dialog .el-dialog__body {
  padding: 20px 28px 8px;
}
.pay-result-box {
  text-align: center;
}
.pay-result-box .el-icon-success {
  color: #28b966;
  font-size: 54px;
}
.result-amount {
  margin: 12px 0 18px;
  font-size: 28px;
  font-weight: 700;
  color: #1f2d3d;
}
.result-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 0;
  border-top: 1px solid #eef2f6;
  font-size: 13px;
  color: #7a8797;
  text-align: left;
}
.result-row strong {
  flex: 1;
  color: #1f2d3d;
  font-weight: 500;
  text-align: right;
  word-break: break-all;
}
</style>
